import styled from "styled-components"
import { Tooltip } from "react-bootstrap"
import { CONFIDENCE_LOW, CONFIDENCE_MEDIUM, CONFIDENCE_HIGH } from "const"
import {
    Container,
    Button,
    TextButton,
} from "client/components"
import { ConfidenceType } from "client/utils/types"


export const KeyResultUpdateListWrapper = styled(Container)`
    position: relative;
    padding: 15px;
    background: ${(props) => props.theme.pageContentBackground};
`
export const DeadlineNotificationWrapper = styled.div`
    display: flex;
    align-items: start;

    & > i {
        color: #a74f0f;
        font-size: 18px;
        margin-right: 6px;
    }
`
export const ConfidenceButton = styled(Button)<{
    confidenceLevel: ConfidenceType
    isActive: boolean
}>`
    background: ${(props) => {
        if (props.confidenceLevel === CONFIDENCE_LOW) return props.theme.confidenceLowBackground
        if (props.confidenceLevel === CONFIDENCE_MEDIUM) return props.theme.confidenceMediumBackground
        if (props.confidenceLevel === CONFIDENCE_HIGH) return props.theme.confidenceHighBackground
        return "none"
    }};
    opacity: ${(props) => (props.isActive ? "1" : "0.5")};
`


export const TooltipStyled = styled(Tooltip)`
    & > .tooltip-inner {
        max-width: unset;
        padding: 8px 14px;
        color: ${(props) => props.theme.tooltipColor};
        background: ${(props) => props.theme.tooltipBackground};
    }

    & > .tooltip-arrow::before {
        border-top-color: ${(props) => props.theme.tooltipBackground};
    }
`


export const UpdateListWrapper = styled.div`
    display: flex;
    flex-direction: column-reverse;
`
export const UpdateWrapper = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${(props) => props.theme.keyResultUpdateBorderColor};
    border-radius: 2px;
    margin-bottom: 15px;
`
export const UpdateTitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid ${(props) => props.theme.keyResultUpdateBorderColor};
`
export const UpdateTitle = styled.div`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    align-items: center;
    padding: 6px 10px;

    & > * {
        margin-right: 10px;
    }
`
export const UpdateTitleConfidence = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 6px 10px;
`
export const UpdateTitlePercents = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 6px 10px;
    font-weight: 600;
    font-size: 15px;
    border-left: 1px solid ${(props) => props.theme.keyResultUpdateBorderColor};
`
export const UpdateBody = styled.div`
    display: flex;
    flex-direction: column;
`
export const UpdateBodyDescriptionWrapper = styled.div`
    display: flex;
    flex-direction: row;
`
export const UpdateBodyDescription = styled.div`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    padding: 6px 10px;
`
export const UpdateBodyPercents = styled.div`
    padding: 6px 10px;
`
export const UpdateBodyOptions = styled.div`
    padding: 4px;
`
export const UpdateBodyNote = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px 10px 6px;
    color: ${(props) => props.theme.keyResultUpdateNote};

    & > i {
        line-height: 22px;
        margin-right: 10px;
    }
`


export const ClockWrapper = styled.div`
    font-size: 12px;
    line-height: 10px;
    color: ${(props) => props.theme.keyResultUpdateClock};
`
export const OptionsButton = styled.div`
    width: 26px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2px;
    background: ${(props) => props.theme.keyResultUpdateOptionsBackground};
    color: ${(props) => props.theme.keyResultUpdateOptionsColor};
    transition: ${(props) => props.theme.defaultTransition};

    &:hover {
        background: ${(props) => props.theme.keyResultUpdateOptionsHoverBackground};
        color: ${(props) => props.theme.keyResultUpdateOptionsHoverColor};
    }
`
export const PercentsChange = styled.div<{
    percents: number
}>`
    position: relative;
    padding: 0 ${(props) => (props.percents === 0 ? "6px" : "24px")} 0 6px;
    border-radius: 2px;
    font-weight: 600;
    font-size: 15px;
    background: ${(props) => {
        if (props.percents > 0) return props.theme.keyResultUpdatePercentsChangePlusBackground
        if (props.percents < 0) return props.theme.keyResultUpdatePercentsChangeMinusBackground
        return props.theme.keyResultUpdatePercentsChangeZeroBackground
    }};

    &::after {
        content: "";
        display: block;
        border-width: 7px 5px;
        border-top-style: solid;
        border-top-color: ${(props) => (props.percents < 0 ? props.theme.keyResultUpdatePercentsChangeMinusColor : "transparent")};
        border-right-style: solid;
        border-right-color: transparent;
        border-bottom-style: solid;
        border-bottom-color: ${(props) => (props.percents > 0 ? props.theme.keyResultUpdatePercentsChangePlusColor : "transparent")};
        border-left-style: solid;
        border-left-color: transparent;
        position: absolute;
        right: 6px;
        top: ${(props) => (props.percents < 0 ? "8px" : "0px")};
    }
`


export const EmptyUpdateListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`
export const EmptyClockWrapper = styled.div`
    font-size: 120px;
    line-height: 120px;
    color: ${(props) => props.theme.keyResultUpdateEmptyListClock};
`
export const EmptyUpdateListTitle = styled.div`
    font-size: 24px;
    text-align: center;
    color: ${(props) => props.theme.defaultTextColor};
`
export const EmptyUpdateListSubtitle = styled.div`
    font-size: 16px;
    text-align: center;
    color: ${(props) => props.theme.keyResultUpdateEmptyListSubtitle};
`
export const EmptyUpdateListTextButton = styled(TextButton)`
    font-size: 18px;
    font-weight: 500;
    color: ${(props) => props.theme.keyResultUpdateEmptyListButtonColor};
`
